import {
  STATIC_REPORT_UI_RENDER_CONFIGS,
  getFiltersToShow,
} from './staticReportConfigs';

const COPY_CHANGES = {
  BREADCRUMB_PATH: 'Reports and analytics /',
  BREADCRUMB_TO: '/reports',
};

const STATIC_REPORTS = [
  'live_job_pipeline',
  'pipeline',
  'hires',
  'jobs',
  'contacts',
  'interviews',
  'offers',
  'rejections',
  'eeo',
  'flow-health',
  'recruiter-performance',
  'requisitions',
];

const REPORT_TYPES = {
  STATIC: 'static',
  CUSTOM: 'custom',
  INVALID: 'invalid',
} as const;

export const REPORT_CONSTANTS = {
  STATIC_REPORT_UI_RENDER_CONFIGS,
  getFiltersToShow,
  COPY_CHANGES,
  STATIC_REPORTS,
  REPORT_TYPES,
};
